module.exports = __webpack_public_path__ + "static/media/icon-fullscreen.7f048ba9.svg";